import { jsx as _jsx } from "react/jsx-runtime";
import { AccordionPanel as ChakraAccordionPanel, } from '@chakra-ui/react';
export const AccordionPanel = ({ children, ...props }) => {
    return (_jsx(ChakraAccordionPanel, { "data-testid": "accordionPanel", ...props, children: children }));
};
//# sourceMappingURL=accordionPanel.js.map